export default __webpack_public_path__ + "static/media/NewYearResolution_12.62195ae8.png";